module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloc bgc-anti-flash-white l-bloc",
    attrs: {
      "id": "bloc-262"
    }
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-deep-lilac",
    attrs: {
      "href": "dash.html"
    }
  }, [_vm._v("Avoimet pyynnöt")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-d",
    attrs: {
      "href": "hyvaksytyt.html"
    }
  }, [_vm._v("Hyväksytyt toimittajat")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-78d00e5a"}!./src/app/components/subnav-project/subnav-project.html
// module id = 492
// module chunks = 1